import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Tokens from "@/pages/Tokens";
import Friends from "@/pages/Friends";
import Invite from "@/pages/Invite";
import Admin from "@/pages/Admin";
import BuyTickets from "@/pages/BuyTickets";
import Leaderboard from "@/pages/Leaderboard";
import Cycles from "@/pages/Cycles";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import ToniniFloatingWidget from "@/components/ToniniFloatingWidget";
import RootRedirect from "@/components/RootRedirect";
import AIChatWidget from "@/components/AIChatWidget";
import AIChatPage from "@/pages/AIChatPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/prijava" element={<Login />} />
          <Route path="/registracija" element={<Register />} />
          <Route path="/zaboravljena-lozinka" element={<ForgotPassword />} />
          <Route path="/reset-lozinke" element={<ResetPassword />} />
          <Route path="/promoteri" element={<Leaderboard />} />
          <Route path="/asistent" element={<AIChatPage />} />
          <Route path="/ciklusi" element={<Cycles />} />
          <Route
            path="/promena-lozinke-obavezna"
            element={
              <ProtectedRoute requirePasswordChange={false}>
                <ForcePasswordChange />
              </ProtectedRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="/tokeni" element={<Tokens />} />
            <Route path="/kupi-tikete" element={<BuyTickets />} />
            <Route path="/prijatelji" element={<Friends />} />
            <Route path="/pozovi" element={<Invite />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <ToniniFloatingWidget />
      <AIChatWidget />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(34,255,119,0.3)",
            color: "#fff",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
